// extracted by mini-css-extract-plugin
module.exports = {"compareInput":"CompareEcgs_compareInput__3N6LM"};